import { render, staticRenderFns } from "./sentry.vue?vue&type=template&id=8cf5856e"
import script from "./sentry.vue?vue&type=script&lang=js"
export * from "./sentry.vue?vue&type=script&lang=js"
import style0 from "./sentry.vue?vue&type=style&index=0&id=8cf5856e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports